const scrollToElement = (element, offset = 0) => {
  if (element) {
    setTimeout(() => {
      // const bodyRect = document.body.getBoundingClientRect().top
      // const elementRect = element.getBoundingClientRect().top
      // const elementPosition = elementRect - bodyRect
      // const offsetPosition = elementPosition - offset

      element.scrollTo({
        // top: offsetPosition,
        behavior: 'smooth',
      })
      // element.scrollIntoView({
      //   behavior: 'smooth',
      //   block: 'start', // You can adjust the alignment as needed
      //   inline: 'nearest', // You can adjust the alignment as needed
      //   top: offset,
      // })
    }, 100)
  }
}

const scrollToFieldError = () => {
  const element = document.querySelector<HTMLInputElement>(`.is-invalid`)
  console.log(element)

  if (!element) return

  setTimeout(() => {
    element?.focus()
  }, 100)
  scrollToElement(element, 50)
}

export {scrollToElement, scrollToFieldError}
